export const LANG_STORAGE_KEY = 'medpronix_lang';

export const LANGS = [
    {
        code: 'ru',
        name: 'Русский',
        native: 'Русский',
        hint: 'Russian',
        short: 'РУ',
    },
    {
        code: 'uz-Latn',
        name: "Oʻzbekcha (lotin)",
        native: "Oʻzbekcha",
        hint: 'Uzbek Latin',
        short: 'UZ',
    },
    {
        code: 'uz-Cyrl',
        name: 'Ўзбекча (кирилл)',
        native: 'Ўзбекча',
        hint: 'Uzbek Cyrillic',
        short: 'ЎЗ',
    },
];

export const DEFAULT_LANG = 'uz-Cyrl';

export function isSupportedLang(code) {
    return LANGS.some((item) => item.code === code);
}

export function getStoredLang() {
    try {
        const stored = localStorage.getItem(LANG_STORAGE_KEY);
        if (isSupportedLang(stored)) return stored;
    } catch {
        /* ignore */
    }
    return DEFAULT_LANG;
}

export function persistLang(code) {
    if (!isSupportedLang(code)) return;
    localStorage.setItem(LANG_STORAGE_KEY, code);
}
